"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class NotFound extends React.Component {
    render() {
        return (React.createElement("div", null,
            React.createElement("section", { className: 'blog-heading text-center', style: {
                    padding: '300px 0',
                    backgroundImage: 'url(https://res.cloudinary.com/dtmavhnux/image/upload/v1498254881/DSC_3225_tzfh26.jpg)',
                } },
                React.createElement("div", { className: 'container' },
                    React.createElement("h1", { className: 'text-uppercase' }, "Not found"),
                    React.createElement("div", { className: 'desc' },
                        React.createElement("p", null, "I can't seem to find the page you're looking for."))))));
    }
}
exports.default = NotFound;
